var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal-card",
      staticStyle: { "min-height": "750px", "overflow-y": "auto" },
    },
    [
      _c("header", { staticClass: "modal-card-head" }, [
        _c("p", { staticClass: "modal-card-title" }, [
          _vm._v(
            " " +
              _vm._s(
                _vm.editableShipping
                  ? _vm.$t(`${_vm.localeRoot}.edit_modal.edit`)
                  : _vm.$t(`${_vm.localeRoot}.edit_modal.create`)
              ) +
              " " +
              _vm._s(_vm.$t(`${_vm.localeRoot}.edit_modal.shipping`)) +
              " "
          ),
        ]),
      ]),
      _c("ValidationObserver", {
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ invalid }) {
              return [
                _c(
                  "section",
                  { staticClass: "modal-card-body" },
                  [
                    _c(
                      "b-field",
                      {
                        attrs: {
                          label: _vm.$t(
                            `${_vm.localeRoot}` + ".edit_modal.reference"
                          ),
                        },
                      },
                      [
                        _c("b-input", {
                          attrs: { name: "reference", type: "text" },
                          model: {
                            value: _vm.newShipping.reference,
                            callback: function ($$v) {
                              _vm.$set(_vm.newShipping, "reference", $$v)
                            },
                            expression: "newShipping.reference",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-field",
                      {
                        attrs: {
                          label: _vm.$t(
                            `${_vm.localeRoot}` +
                              ".edit_modal.reference_complement"
                          ),
                        },
                      },
                      [
                        _c("b-input", {
                          attrs: { name: "referenceComplement", type: "text" },
                          model: {
                            value: _vm.newShipping.referenceComplement,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.newShipping,
                                "referenceComplement",
                                $$v
                              )
                            },
                            expression: "newShipping.referenceComplement",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-field",
                      {
                        attrs: {
                          label: _vm.$t(
                            `${_vm.localeRoot}` + ".edit_modal.date"
                          ),
                        },
                      },
                      [
                        _c("b-datetimepicker", {
                          attrs: {
                            "max-datetime": _vm.now,
                            icon: "calendar-alt",
                            placeholder: _vm.$t(
                              `${_vm.localeRoot}` + ".edit_modal.date"
                            ),
                            editable: "",
                          },
                          model: {
                            value: _vm.newShipping.creation_date,
                            callback: function ($$v) {
                              _vm.$set(_vm.newShipping, "creation_date", $$v)
                            },
                            expression: "newShipping.creation_date",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-field",
                      {
                        attrs: {
                          label: _vm.$t(
                            `${_vm.localeRoot}` + ".edit_modal.consignee"
                          ),
                        },
                      },
                      [
                        _c("multiselect", {
                          staticClass: "z-9",
                          attrs: {
                            options: _vm.endusers,
                            multiple: false,
                            "close-on-select": true,
                            "clear-on-select": true,
                            "allow-empty": true,
                            "preserve-search": true,
                            placeholder: "Pick consignee...",
                            "custom-label": (enduser) => {
                              return (
                                enduser.partnerReference +
                                " - " +
                                enduser.name +
                                " | " +
                                enduser.city +
                                " - " +
                                enduser.country
                              )
                            },
                            "track-by": "name",
                          },
                          model: {
                            value: _vm.newShipping.enduser,
                            callback: function ($$v) {
                              _vm.$set(_vm.newShipping, "enduser", $$v)
                            },
                            expression: "newShipping.enduser",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-field",
                      {
                        attrs: {
                          label: _vm.$t(
                            `${_vm.localeRoot}` + ".edit_modal.scan_user"
                          ),
                        },
                      },
                      [
                        _c("multiselect", {
                          staticClass: "z-9",
                          attrs: {
                            options: _vm.scanUsers,
                            multiple: false,
                            "close-on-select": true,
                            "clear-on-select": true,
                            "allow-empty": true,
                            "preserve-search": true,
                            placeholder: "Pick user...",
                            label: "name",
                            "track-by": "id",
                          },
                          model: {
                            value: _vm.newShipping.scanUser,
                            callback: function ($$v) {
                              _vm.$set(_vm.newShipping, "scanUser", $$v)
                            },
                            expression: "newShipping.scanUser",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("b-field", {
                      attrs: {
                        label: _vm.$t(
                          `${_vm.localeRoot}` + ".edit_modal.crates"
                        ),
                      },
                    }),
                    _c(
                      "b-field",
                      [
                        _c("b-input", {
                          attrs: {
                            placeholder: _vm.$t(
                              `${_vm.localeRoot}` + ".edit_modal.search"
                            ),
                            type: "search",
                          },
                          model: {
                            value: _vm.crateSearch,
                            callback: function ($$v) {
                              _vm.crateSearch = $$v
                            },
                            expression: "crateSearch",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("b-field", [
                      _c(
                        "div",
                        { staticClass: "crateMovements" },
                        _vm._l(_vm.filteredCrates, function (crateMovement) {
                          return _c(
                            "span",
                            {
                              key: crateMovement.id,
                              staticClass: "tag crates",
                              class: [
                                { "is-link": !crateMovement.toDelete },
                                { "is-danger": crateMovement.toDelete },
                              ],
                              on: {
                                click: function ($event) {
                                  return _vm.setToDelete(crateMovement)
                                },
                              },
                            },
                            [_vm._v(_vm._s(crateMovement.barcode))]
                          )
                        }),
                        0
                      ),
                    ]),
                    _c(
                      "b-field",
                      {
                        attrs: {
                          label: _vm.$t(
                            `${_vm.localeRoot}` + ".edit_modal.add_crate"
                          ),
                        },
                      },
                      [
                        _c("b-input", {
                          attrs: { name: "crates", type: "text" },
                          nativeOn: {
                            keydown: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              return _vm.addCrateMovement()
                            },
                          },
                          model: {
                            value: _vm.newCrateMovement,
                            callback: function ($$v) {
                              _vm.newCrateMovement = $$v
                            },
                            expression: "newCrateMovement",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "is-pulled-right" }, [
                      _c("p", { staticClass: "control" }, [
                        _c(
                          "a",
                          {
                            staticClass: "button is-small is-primary",
                            attrs: { disabled: _vm.addingCrate },
                            on: {
                              click: function ($event) {
                                return _vm.addCrateMovement()
                              },
                            },
                          },
                          [
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(`${_vm.localeRoot}.edit_modal.add`)
                                )
                              ),
                            ],
                          ],
                          2
                        ),
                        _vm.crateMovements.find((crate) => {
                          return crate.toDelete
                        })
                          ? _c(
                              "a",
                              {
                                staticClass: "button is-small is-danger",
                                on: {
                                  click: function ($event) {
                                    return _vm.removeCrate()
                                  },
                                },
                              },
                              [
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        `${_vm.localeRoot}.edit_modal.delete`
                                      )
                                    )
                                  ),
                                ],
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm.crateMovements.find((crate) => {
                          return crate.toDelete
                        }) && !_vm.splittingShipping
                          ? _c(
                              "a",
                              {
                                staticClass: "button is-small is-warning",
                                on: {
                                  click: function ($event) {
                                    return _vm.moveToNewShipping()
                                  },
                                },
                              },
                              [
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        `${_vm.localeRoot}.edit_modal.move_new_shipping`
                                      )
                                    )
                                  ),
                                ],
                              ],
                              2
                            )
                          : _vm._e(),
                      ]),
                    ]),
                    _vm._l(_vm.dynamicFields, function (el, i) {
                      return _c(
                        "b-field",
                        { key: i, attrs: { label: el.displayName } },
                        [
                          el.type === "text"
                            ? _c("b-input", {
                                attrs: {
                                  value: _vm.getValue(el),
                                  name: "crates",
                                  type: "text",
                                },
                                on: {
                                  input: (params) => _vm.onInput(params, el),
                                },
                              })
                            : _vm._e(),
                          el.type === "select"
                            ? _c(
                                "b-select",
                                {
                                  attrs: { value: _vm.getValue(el) },
                                  on: {
                                    input: (params) => _vm.onInput(params, el),
                                  },
                                },
                                _vm._l(el.selectFields, function (el2, i2) {
                                  return _c(
                                    "option",
                                    { key: i2, domProps: { value: el2.value } },
                                    [_vm._v(" " + _vm._s(el2.label) + " ")]
                                  )
                                }),
                                0
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    }),
                  ],
                  2
                ),
                _c("footer", { staticClass: "modal-card-foot" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button is-info is-fullwidth",
                      class: { "is-loading": _vm.isSubmitting },
                      attrs: { disabled: invalid, type: "submit" },
                      on: { click: _vm.submit },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(`${_vm.localeRoot}.edit_modal.submit`)
                          ) +
                          " "
                      ),
                    ]
                  ),
                ]),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }